import { IZonesState } from './types';

export const SLICE_NAMESPACE = 'zones';

export const initialState: IZonesState = {
  zones: [],
  isLoading: false,
};
